import ReactMarkdown from 'react-markdown'
import { MARKDOWN_TILLAGG } from '../lib/markdown'
import kursplan from '../content/kursplan.md?raw'
import { useSidTitel } from '../lib/seo'
import { KURSKOD } from '../lib/site'

export default function Kursplan() {
  useSidTitel(`Skolverkets kursplan${KURSKOD ? ` (${KURSKOD}, Gy25)` : ' (Gy25)'}`)
  return (
    <div className="wrap">
      <article className="dokument">
        {/* kursplan.md synkas ordagrant från källans underlag/kursplan/ (se
            scripts/sync-content.mjs) — formulera aldrig om den härifrån; ändras
            ämnesplanen hos Skolverket uppdateras den i källrepot, inte här. */}
        {kursplan ? (
          <ReactMarkdown remarkPlugins={MARKDOWN_TILLAGG}>{kursplan}</ReactMarkdown>
        ) : (
          <p>Kursplanen är inte synkad från källan ännu.</p>
        )}
      </article>
    </div>
  )
}
